import { clsx } from 'clsx';
import { RefObject } from 'react';
import { APP_BG_COLOR } from '../utils/globalStyles';

type FooterProps = {
  elementRef?: RefObject<HTMLElement>;
};

export function Footer({ elementRef }: FooterProps) {
  const dateObj = new Date();
  return (
    <footer ref={elementRef} className={clsx('tw:w-full', APP_BG_COLOR)}>
      <div className="tw:px-4 tw:py-2">
        <div className="tw:flex tw:items-center tw:justify-center">
          <div className="tw:text-center tw:text-xs tw:text-zinc-600 sm:tw:text-sm">
            © {dateObj.getFullYear()} Send-it Healthcare Inc. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
